export default "__VITE_ASSET__D23q1int__"